<div class="page-content">
    <div class="container-fluid">


        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">{{action.MenuTitle}}</h4>
                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item"><a routerLink="/admin/admin-dashboard">Dashboard</a></li>
                            <li class="breadcrumb-item active">{{action.ParentMenuTitle}}</li>
                            <li class="breadcrumb-item">{{action.MenuTitle}}</li>
                        </ol>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <!-- <h4 class="card-title">Default Datatable</h4> -->

                        <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div class="row mb-2">
                                <!-- New Page Group Button - top right -->
                                <div class="col-12 d-flex justify-content-end mb-2">
                                    @if (action.CanCreate) {
                                    <button mat-raised-button color="primary" (click)="openModal()">
                                        New Page Group
                                    </button>
                                    }
                                </div>

                                <!-- Show Entries - left -->
                                <div class="col-sm-12 col-md-4">
                                    <div class="dataTables_length">
                                        <label>Show
                                            <select
                                                class="custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                [(ngModel)]="itemPerPage">
                                                @for (option of PageSize; track option) {
                                                <option [value]="option">{{ option }}</option>
                                                }
                                            </select> entries
                                        </label>
                                    </div>
                                </div>

                                <!-- Search - right -->
                                <div class="col-sm-12 col-md-4 ms-auto">
                                    <div class="dataTables_filter d-flex justify-content-end">
                                        <label>Search:
                                            <input type="search" class="form-control form-control-sm" placeholder=""
                                                [(ngModel)]="Search">
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <table id="datatable"
                                        class="table table-bordered  dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                        role="grid" aria-describedby="datatable_info" style="width: 1185px;">
                                        <thead>
                                            <tr role="row">

                                                <th class="sorting_desc">S.No</th>
                                                <th class="sorting_desc" (click)="sort('PageGroupName')"
                                                    style="cursor:pointer">PageGroup</th>
                                                <th class="sorting_desc" (click)="sort('Status')"
                                                    style="cursor:pointer">Status</th>
                                                <!-- <th class="sorting_desc" (click)="sort('Status')">Status</th> -->
                                                @if (action.CanEdit) { <th>Edit</th> }
                                                @if (action.CanDelete) { <th>Delete</th> }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (item of PageGroupList; track item.PageGroupId; let i = $index) {
                                            <tr>
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ item.PageGroupName }}</td>
                                                <td>
                                                    <span class="p-1"
                                                        [ngClass]="item.Status == 1 ? 'badge text-bg-success' : 'badge text-bg-danger'">
                                                        {{ AllStatusList[item.Status] }}
                                                    </span>
                                                </td>
                                                @if (action.CanEdit) {
                                                <td>
                                                    <a class="text-success p-1" (click)="editPageGroup(item)">
                                                        <i class="bx bxs-edit-alt"></i>
                                                    </a>
                                                </td>
                                                }
                                                @if (action.CanDelete) {
                                                <td>
                                                    <a class="text-danger p-1" (click)="deletePageGroup(item)">
                                                        <i class="bx bxs-trash"></i>
                                                    </a>
                                                </td>
                                                }
                                            </tr>
                                            }

                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <pagination-controls (pageChange)="onTableDataChange($event)" style="float:right;"
                                        class="my-pagination">
                                    </pagination-controls>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    <!-- <pagination-controls (pageChange)="onTableDataChange($event)" style="float:right;"
                                        class="my-pagination"></pagination-controls> -->
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div> <!-- end col -->
        </div>



        <!-- <div class="row mb-3">
            <div class="col-sm-4">
                @if (action.CanCreate) {
                <button mat-raised-button color="primary" class="float-end" (click)="openModal()">
                    New Page Group
                </button>
                }
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="dataTable-top">
                            <div class="dataTable-dropdown d-flex">
                                <select class="dataTable-selector form-select form-select-sm" [(ngModel)]="itemPerPage">
                                    @for (option of PageSize; track option) {
                                    <option [value]="option">{{ option }}</option>
                                    }
                                </select>
                                <span class="ms-2">Entries per page</span>
                            </div>
                            <div class="dataTable-search">
                                <input class="dataTable-input form-control form-control-sm" [(ngModel)]="Search"
                                    placeholder="Search..." type="text">
                            </div>
                        </div>

                        <div class="table-container overflow-auto">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th (click)="sort('PageGroupName')" style="cursor:pointer">PageGroup</th>
                                        <th (click)="sort('Status')" style="cursor:pointer">Status</th>
                                        @if (action.CanEdit) { <th>Edit</th> }
                                        @if (action.CanDelete) { <th>Delete</th> }
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of PageGroupList; track item.PageGroupId; let i = $index) {
                                    <tr>
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ item.PageGroupName }}</td>
                                        <td>
                                            <span class="p-1"
                                                [ngClass]="item.Status == 1 ? 'badge text-bg-success' : 'badge text-bg-danger'">
                                                {{ AllStatusList[item.Status] }}
                                            </span>
                                        </td>
                                        @if (action.CanEdit) {
                                        <td>
                                            <button class="btn btn-sm btn-warning" (click)="editPageGroup(item)">
                                                <i class="bi bi-pencil-square"></i>
                                            </button>
                                        </td>
                                        }
                                        @if (action.CanDelete) {
                                        <td>
                                            <button class="btn btn-sm btn-danger" (click)="deletePageGroup(item)">
                                                <i class="bi bi-trash-fill"></i>
                                            </button>
                                        </td>
                                        }
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>



        </div> -->
    </div>

    <!-- Modal -->
    @if (showModal && (action.CanEdit || action.CanCreate)) {
    <div class="modal fade show d-block" tabindex="-1" style="background:rgba(0,0,0,0.5)">
        <div class="modal-dialog">
            <div class="modal-content">

                <div class="modal-header">
                    <h1 class="modal-title fs-5">
                        {{ PageGroup.PageGroupId > 0 ? 'Update' : 'New' }} Page Group
                    </h1>
                    <button type="button" class="btn-close" (click)="closeModal()"></button>
                </div>

                <div class="modal-body">
                    <form #formPageGroup="ngForm">
                        <div class="container">
                            <div class="row">

                                <mat-form-field appearance="outline" class="col-sm-12">
                                    <mat-label>Group Name</mat-label>
                                    <input matInput #PageGroupName="ngModel" name="PageGroupName"
                                        [(ngModel)]="PageGroup.PageGroupName" required autofocus>
                                    @if ((PageGroupName.dirty || PageGroupName.touched) ||
                                    (PageGroupName.invalid &&
                                    isSubmitted)) {
                                    <mat-error>Page group name is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="col-sm-12">
                                    <mat-label>Status</mat-label>
                                    <mat-select #Status="ngModel" name="Status" [(ngModel)]="PageGroup.Status" required>
                                        @for (status of StatusList; track status.Key) {
                                        <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                                        }
                                    </mat-select>
                                    @if ((Status.dirty || Status.touched) || (Status.invalid && isSubmitted)) {
                                    <mat-error>Status is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                            </div>
                        </div>
                    </form>
                </div>

                <div class="modal-footer mt-2">
                    <button type="button" mat-raised-button color="warn" class="me-2"
                        (click)="closeModal()">Cancel</button>
                    <button mat-raised-button color="primary" (click)="savePageGroup()">
                        {{ PageGroup.PageGroupId > 0 ? 'Update' : 'Submit' }}
                    </button>
                </div>

            </div>
        </div>
    </div>
    }
    <!-- Modal -->